// // ############################ New code updated #################################
// /* eslint-disable */
// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import jwt_decode from "jwt-decode";
// import axios from 'axios';
// import { Form, Button, Row, Col, Table, Pagination, ProgressBar } from 'react-bootstrap';
// import * as XLSX from 'xlsx';
// import Papa from 'papaparse';
// import { usePopupManager } from '../../providers/PopupManager/PopupManager';
// import { MESSAGE_TYPE } from '../../constants';
// import config from '../../config/config';
// import GridLoadingSpinner from '../GridLoadingSpinner/GridLoadingSpinner';
// import styles from './FileUploadComp.module.css';

// const MAX_RECORDS = 10000;
// const PAGE_SIZE = 100;

// const { API_BASE_URL } = config;

// const FileUploadComp = () => {
//   // eslint-disable-next-line no-unused-expressions, no-undef
//   const UserToken = keycloak.token;
//   let username = '';
//   let Email = '';

//   if(UserToken !== undefined || UserToken !== null){
//     const decoded = jwt_decode(UserToken);
//     username = decoded.preferred_username
//     Email = decoded.email
//   } else{
//     console.log("test null..!")
//   }

//   const { showPopup } = usePopupManager();

//   const [fileName, setFileName] = useState('');
//   const [file, setFile] = useState(null);
//   const [fullData, setFullData] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [entityOptions, setEntityOptions] = useState([]);
//   const [entity, setEntity] = useState('undefined');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [isUploading, setIsUploading] = useState(false);

//   const [showSubmitButton, setshowSubmitButton] = useState(true);

//   useEffect(() => {
//     const fetchEntityOptions = async () => {
//       try {
//         const response = await axios.post(`${API_BASE_URL}/api/file-upload-entity-options`, 
//           {user_name: username},
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem('ApiToken')}`
//             }
//           }
//         );
//         const options = response.data.entityOptions;
//         setEntityOptions(options);
//       } catch (error) {
//         console.error("Failed to fetch entity options:", error);
//       }
//     };

//     fetchEntityOptions();
//   }, []);

//   const handleFileChange = (e) => {
//     setshowSubmitButton(true);
//     const selectedFile = e.target.files[0];
//     // const allowedExtensions = ['csv', 'xls', 'xlsx'];
//     const allowedExtensions = ['csv'];
//     const fileExtension = selectedFile?.name.split('.').pop();
//     if (selectedFile && allowedExtensions.includes(fileExtension)) {
//       setFile(selectedFile);
//       setFileName(selectedFile.name);
//     } else {
//       // alert('Please upload a valid Excel or CSV file.');
//       showPopup({
//         type: MESSAGE_TYPE.FAILURE,
//         contextText: MESSAGE_TYPE.FAILURE,
//         info: "Only upload a valid CSV file.",
//       });
//       e.target.value = null;
//       setFile(null);
//       setFileName('');
//     }
//   };

//   const handleView = () => {
//     if (!file) {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "No file selected.",
//       });
//       return;
//     }
//     if (entity === 'undefined') {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "Select entity.",
//       });
//       return;
//     } 
//     const reader = new FileReader();
//     const ext = file.name.split('.').pop();
//     const processData = (data) => {
//       const limited = data.slice(0, MAX_RECORDS);
//       setFullData(limited);
//       setHeaders(Object.keys(limited[0] || {}));
//       setCurrentPage(1);
//       setTableData(limited.slice(0, PAGE_SIZE));
//     };
//     if (ext === 'csv') {
//       reader.onload = (e) => {
//         const text = e.target.result;
//         Papa.parse(text, {
//           header: true,
//           complete: (result) => processData(result.data),
//         });
//       };
//       reader.readAsText(file);
//       setshowSubmitButton(false);
//     } else {
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });
//         const sheetName = workbook.SheetNames[0];
//         const sheet = workbook.Sheets[sheetName];
//         const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
//         processData(jsonData);
//       };
//       reader.readAsArrayBuffer(file);
//       setshowSubmitButton(false);
//     }
//   };

//   const handleEntity = (val) => {
//     setEntity(val);
//   }

//   const handleSubmit = async (e) => {
//     if (!file) {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "No file selected.",
//       });
//       return;
//     }
//     if (entity === 'undefined') {
//       showPopup({
//         type: MESSAGE_TYPE.INFORMATION,
//         contextText: MESSAGE_TYPE.INFORMATION,
//         info: "Select entity.",
//       });
//       return;
//     }
//     const formData = new FormData();
//     formData.append('user_id', username);
//     formData.append('entity_name', entity.label);
//     formData.append('file_name', file.name);
//     formData.append('status', 'Pending');
//     formData.append('approved_name', entity.value);
//     formData.append('uploaded_file', file);

//     try {
//       const token = localStorage.getItem('ApiToken');
//       setIsUploading(true);
//       setUploadProgress(0);
//       const response = await axios.post(
//         `${API_BASE_URL}/api/file-upload-maker`,
//         formData,
//         {
//           headers: {
//             'Content-Type': 'multipart/form-data',
//             Authorization: `Bearer ${token}`,
//           },
//           onUploadProgress: (progressEvent) => {
//             const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//             setUploadProgress(percentCompleted);
//           }
//         }
//       );

//       showPopup({
//         type: MESSAGE_TYPE.SUCCESS,
//         contextText: MESSAGE_TYPE.SUCCESS,
//         info: "File uploaded successfully",
//       });
//     } catch (error) {
//       // console.error('Upload error:', error.response?.data || error.message);
//       const errorMessage = error.response?.data?.error || "File upload failed";
//       showPopup({
//         type: MESSAGE_TYPE.FAILURE,
//         contextText: MESSAGE_TYPE.FAILURE,
//         info: errorMessage,
//       });
//     } finally {
//       setIsUploading(false);
//     }
//   };

//   const handlePageChange = (pageNumber) => {
//     const start = (pageNumber - 1) * PAGE_SIZE;
//     const end = start + PAGE_SIZE;
//     setCurrentPage(pageNumber);
//     setTableData(fullData.slice(start, end));
//   };

//   const renderPagination = () => {
//     const totalPages = Math.ceil(fullData.length / PAGE_SIZE);
//     let items = [];
//     items.push(
//       <Pagination.Prev
//         key="prev"
//         disabled={currentPage === 1}
//         onClick={() => handlePageChange(currentPage - 1)}
//       />
//     );

//     for (let i = 1; i <= totalPages; i++) {
//       if (
//         i === 1 || i === totalPages || 
//         (i >= currentPage - 2 && i <= currentPage + 2)
//       ) {
//         items.push(
//           <Pagination.Item
//             key={i}
//             active={i === currentPage}
//             onClick={() => handlePageChange(i)}
//           >
//             {i}
//           </Pagination.Item>
//         );
//       } else if (
//         (i === currentPage - 3 && i !== 2) ||
//         (i === currentPage + 3 && i !== totalPages - 1)
//       ) {
//         items.push(<Pagination.Ellipsis key={`ellipsis-${i}`} disabled />);
//       }
//     }
//     items.push(
//       <Pagination.Next
//         key="next"
//         disabled={currentPage === totalPages}
//         onClick={() => handlePageChange(currentPage + 1)}
//       />
//     );
//     return <Pagination>{items}</Pagination>;
//   };


//   return (
//     <div className={`${styles.filter_panel_container}`}>
//       <Row className="align-items-end">
//         <Col md={4}>
//           <label className="fw-bold">Entity<span style={{color:"#f44336"}}>*</span></label>
//           <Select
//             placeholder="select entity"
//             value={entity}
//             onChange={handleEntity}
//             options={entityOptions}
//             isSearchable={false}
//             menuPortalTarget={document.body}
//             styles={{
//               menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//             }}
//           />
//         </Col>

//         <Col md={5}>
//           <label className="fw-bold">Select a file<span style={{color:"#f44336"}}>*</span></label>
//           <div className="d-flex">
//             <Form.Control
//               type="text"
//               value={fileName}
//               placeholder="No file selected"
//               readOnly
//               className="me-2"
//             />
//             <Button variant="secondary" onClick={() => document.getElementById('hiddenFileInput').click()}>
//               Browse
//             </Button>
//             <Form.Control
//               type="file"
//               id="hiddenFileInput"
//               style={{ display: 'none' }}
//               accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//               onChange={handleFileChange}
//             />
//           </div>
//         </Col>

//         <Col md={3} className="d-flex gap-2 mt-3 mt-md-0">
//           <Button variant="outline-secondary" onClick={handleView}>View</Button>
//           <Button variant="primary" disabled={showSubmitButton} onClick={handleSubmit}>Submit</Button>
//         </Col>
//         {isUploading && (
//           <div
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               width: '100vw',
//               height: '100vh',
//               backgroundColor: 'rgba(255, 255, 255, 0.8)',
//               zIndex: 9999,
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'center',
//               alignItems: 'center',
//             }}
//           >
//             <div className="text-center">
//               <div className="spinner-border text-primary mb-3" role="status"></div>
//               <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Uploading File...</p>
//               <ProgressBar
//                 now={uploadProgress}
//                 label={`${uploadProgress}%`}
//                 animated
//                 striped
//                 style={{ width: '300px' }}
//               />
//             </div>
//           </div>
//         )}
//       </Row>
//       {tableData.length > 0 && (
//         <div className="mt-4">
//           <div className="py-3">
//             <h5>
//               Uploaded File Data (showing {tableData.length} of {fullData.length} records)
//             </h5>
//           </div>
//           <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
//             <Table hover size="sm" className="mb-0">
//               <thead className="table-light custom-thead" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
//                 <tr>
//                   {headers.map((header, idx) => (
//                     <th key={idx}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody className="custom-tbody">
//                 {tableData.map((row, i) => (
//                   <tr key={i}>
//                     {headers.map((header, j) => (
//                       <td key={j}>{row[header]}</td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//           <div className="d-flex justify-content-end mt-3">
//             {renderPagination()}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FileUploadComp;


// ######################## New Code with Template download ###########################

/* eslint-disable */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import { Form, Button, Row, Col, Table, Pagination, ProgressBar } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../constants';
import config from '../../config/config';
import GridLoadingSpinner from '../GridLoadingSpinner/GridLoadingSpinner';
import styles from './FileUploadComp.module.css';

const MAX_RECORDS = 10000;
const PAGE_SIZE = 100;

const { API_BASE_URL } = config;

const FileUploadComp = () => {
  const UserToken = keycloak.token;
  let username = '';
  let Email = '';

  if (UserToken !== undefined || UserToken !== null) {
    const decoded = jwt_decode(UserToken);
    username = decoded.preferred_username
    Email = decoded.email
  } else {
    console.log("test null..!")
  }

  const { showPopup } = usePopupManager();
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  const [fullData, setFullData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [entity, setEntity] = useState('undefined');
  const [currentPage, setCurrentPage] = useState(1);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [showSubmitButton, setshowSubmitButton] = useState(true);

  useEffect(() => {
    const fetchEntityOptions = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/file-upload-entity-options`,
          { user_name: username },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('ApiToken')}`
            }
          }
        );
        const options = response.data.entityOptions;
        setEntityOptions(options);
      } catch (error) {
        console.error("Failed to fetch entity options:", error);
      }
    };

    fetchEntityOptions();
  }, []);

  const handleFileChange = (e) => {
    setshowSubmitButton(true);
    const selectedFile = e.target.files[0];
    const allowedExtensions = ['csv'];
    const fileExtension = selectedFile?.name.split('.').pop();
    if (selectedFile && allowedExtensions.includes(fileExtension)) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    } else {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Only upload a valid CSV file.",
      });
      e.target.value = null;
      setFile(null);
      setFileName('');
    }
  };

  const handleView = () => {
    if (!file) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "No file selected.",
      });
      return;
    }
    if (entity === 'undefined') {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Select entity.",
      });
      return;
    }
    const reader = new FileReader();
    const ext = file.name.split('.').pop();
    const processData = (data) => {
      const limited = data.slice(0, MAX_RECORDS);
      setFullData(limited);
      setHeaders(Object.keys(limited[0] || {}));
      setCurrentPage(1);
      setTableData(limited.slice(0, PAGE_SIZE));
    };
    if (ext === 'csv') {
      reader.onload = (e) => {
        const text = e.target.result;
        Papa.parse(text, {
          header: true,
          complete: (result) => processData(result.data),
        });
      };
      reader.readAsText(file);
      setshowSubmitButton(false);
    } else {
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        processData(jsonData);
      };
      reader.readAsArrayBuffer(file);
      setshowSubmitButton(false);
    }
  };

  const handleEntity = (val) => {
    setEntity(val);
  }

  const handleDownloadTemp = async () => {
    try {
      if (!entity?.label) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please select an entity before downloading the template.",
        });
        return;
      }

      const token = localStorage.getItem('ApiToken');
      if (!token) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Session expired. Please log in again.",
        });
        return;
      }

      const formData = new FormData();
      formData.append("entity_name", entity.label);
      formData.append("username", username);

      const response = await axios.post(
        `${API_BASE_URL}/api/file-upload-template-download`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
          responseType: 'blob',
        }
      );

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      let fileName = `${entity.label}_template.xlsx`;
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("File download failed:");
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Failed to download template. Please try again.",
      });
      // alert("Failed to download template. Please try again.");
    }
  };


  const handleSubmit = async (e) => {
    if (!file) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "No file selected.",
      });
      return;
    }
    if (entity === 'undefined') {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Select entity.",
      });
      return;
    }
    const formData = new FormData();
    formData.append('user_id', username);
    formData.append('entity_name', entity.label);
    formData.append('file_name', file.name);
    formData.append('status', 'Pending');
    formData.append('approved_name', entity.value);
    formData.append('uploaded_file', file);

    try {
      const token = localStorage.getItem('ApiToken');
      setIsUploading(true);
      setUploadProgress(0);
      const response = await axios.post(
        `${API_BASE_URL}/api/file-upload-maker`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          }
        }
      );

      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: MESSAGE_TYPE.SUCCESS,
        info: "File uploaded successfully",
      });
    } catch (error) {
      const errorMessage = error.response?.data?.error || "File upload failed";
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: errorMessage,
      });
    } finally {
      setIsUploading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    const start = (pageNumber - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;
    setCurrentPage(pageNumber);
    setTableData(fullData.slice(start, end));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(fullData.length / PAGE_SIZE);
    let items = [];
    items.push(
      <Pagination.Prev
        key="prev"
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      />
    );

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 || i === totalPages ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      } else if (
        (i === currentPage - 3 && i !== 2) ||
        (i === currentPage + 3 && i !== totalPages - 1)
      ) {
        items.push(<Pagination.Ellipsis key={`ellipsis-${i}`} disabled />);
      }
    }
    items.push(
      <Pagination.Next
        key="next"
        disabled={currentPage === totalPages}
        onClick={() => handlePageChange(currentPage + 1)}
      />
    );
    return <Pagination>{items}</Pagination>;
  };


  return (
    <>
      <div className={`${styles.filter_panel_container}`}>
        <Row className="align-items-end">
          <Col md={3}>
            <label className="fw-bold">Entity<span style={{ color: "#f44336" }}>*</span></label>
            <Select
              placeholder="select entity"
              value={entity}
              onChange={handleEntity}
              options={entityOptions}
              isSearchable={false}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Col>

          <Col md={5}>
            <label className="fw-bold">Select a file<span style={{ color: "#f44336" }}>*</span></label>
            <div className="d-flex">
              <Form.Control
                type="text"
                value={fileName}
                placeholder="No file selected"
                readOnly
                className="me-2"
              />
              <Button variant="secondary" onClick={() => document.getElementById('hiddenFileInput').click()}>
                Browse
              </Button>
              <Form.Control
                type="file"
                id="hiddenFileInput"
                style={{ display: 'none' }}
                accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleFileChange}
              />
            </div>
          </Col>

          <Col md={4} className="d-flex gap-2 mt-3 mt-md-0">
            <Button variant="outline-secondary" onClick={handleView}>View</Button>
            <Button variant="primary" disabled={showSubmitButton} onClick={handleSubmit}>Submit</Button>
            <Button style={{ border: "1px solid #60c1a3", backgroundColor: "#60c1a3", color: "#fff", fontSize: "1em" }} onClick={handleDownloadTemp}>Download Template</Button>
          </Col>
          {isUploading && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                zIndex: 9999,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className="text-center">
                <div className="spinner-border text-primary mb-3" role="status"></div>
                <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Uploading File...</p>
                <ProgressBar
                  now={uploadProgress}
                  label={`${uploadProgress}%`}
                  animated
                  striped
                  style={{ width: '300px' }}
                />
              </div>
            </div>
          )}
        </Row>
        {tableData.length > 0 && (
          <div className="mt-4">
            <div className="py-3">
              <h5>
                Uploaded File Data (showing {tableData.length} of {fullData.length} records)
              </h5>
            </div>
            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <Table hover size="sm" className="mb-0">
                <thead className="table-light custom-thead" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                  <tr>
                    {headers.map((header, idx) => (
                      <th key={idx}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody className="custom-tbody">
                  {tableData.map((row, i) => (
                    <tr key={i}>
                      {headers.map((header, j) => (
                        <td key={j}>{row[header]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-end mt-3">
              {renderPagination()}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FileUploadComp;
